import { connect, useDispatch } from "react-redux";
import { MAppLogo, MAppLogoW, MSetting } from "./MIcon";
import { useCallback, useEffect, useState } from "react";
import { AppConstant } from "../../redux/reducers";

const LOGO_TIMEOUT_MS = 5000;

const MPageHeader = ({ isWhite = false, callbackClickLogo, css = "", group, groupLoading, avatarItem }) => {
  const dispatch = useDispatch();
  const [imgError, setImgError] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  // persist로 복원된 그룹 로고가 현재 avatarItem의 그룹과 일치하는지 판단.
  // group._id === ownerGroupId인 경우 이미 유효한 로고가 있으므로 타이머 불필요.
  const hasPersistLogo =
    group?._id &&
    avatarItem?.ownerGroupId &&
    group._id === avatarItem.ownerGroupId &&
    group?.logo?.trim() &&
    !imgError;

  // groupLoading이 true이고 ownerGroupId가 있으며 이미 유효 로고가 없을 때만 타이머 시작.
  // 이미 유효 로고가 표시 중이면 타이머를 걸 필요 없다.
  // 재진입 시(false→true 전이) timedOut을 리셋해 스켈레톤이 정상 노출되도록 한다.
  useEffect(() => {
    if (!groupLoading) {
      setTimedOut(false);
      return;
    }
    if (!avatarItem?.ownerGroupId || hasPersistLogo) {
      return;
    }
    setTimedOut(false);
    const timer = setTimeout(() => {
      setTimedOut(true);
    }, LOGO_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [groupLoading, avatarItem?.ownerGroupId, hasPersistLogo]);

  // group이 바뀌면 이미지 에러 플래그 초기화
  useEffect(() => {
    setImgError(false);
  }, [group?.logo]);

  const openSetting = useCallback(() => {
    dispatch({ type: AppConstant.SET_SHOW_SETTING, show: true });
  }, [dispatch]);

  const handlerClickLogo = useCallback(() => {
    callbackClickLogo && callbackClickLogo();
  }, [callbackClickLogo]);

  // 렌더 우선순위:
  // 1. 그룹 로고(stale 허용): persist 복원 or 로드 완료된 현재 그룹 로고. groupLoading 무관.
  // 2. 스켈레톤: 로딩 중이고 유효 로고 없음.
  // 3. 앱 로고(fallback): 그 외.
  const showSkeleton = !hasPersistLogo && groupLoading && !timedOut && avatarItem?.ownerGroupId;

  const renderLogo = () => {
    if (hasPersistLogo) {
      return (
        <img
          src={group.logo}
          alt=""
          style={{ height: 38, width: "auto", objectFit: "contain", cursor: callbackClickLogo ? "pointer" : "default" }}
          onClick={handlerClickLogo}
          onError={() => setImgError(true)}
        />
      );
    }
    if (showSkeleton) {
      return (
        <div
          className={`header-logo-skeleton${isWhite ? " header-logo-skeleton--white" : ""}`}
        />
      );
    }
    if (isWhite) {
      return <MAppLogoW height={32} onClick={handlerClickLogo} />;
    }
    return <MAppLogo height={32} onClick={handlerClickLogo} />;
  };

  // 그룹 로고(로딩 스켈레톤 포함)는 좌측을 꽉 채우도록 ps-1(4px), 앱 로고 fallback은 기존 ps-4 유지
  const logoPs = (hasPersistLogo || showSkeleton) ? "ps-1" : "ps-4";

  return <>
    <div className={`d-flex align-items-center justify-content-between ${logoPs} pe-2 py-1 ${css}`}>
      {renderLogo()}
      <div>
        <MSetting className="text-gray-300 cursor-pointer" onClick={openSetting} />
      </div>
    </div>
  </>;
};

const mapState = (state) => {
  const avatarId = state.AvatarReducer.id;
  const avatarItem = state.AvatarReducer.item;
  const pageTitle = state.AppReducer.pageTitle;
  const group = state.AuthReducer.group;
  const groupLoading = state.AuthReducer.groupLoading;
  return { pageTitle, avatarId, avatarItem, group, groupLoading };
};

const mapDispatch = dispatch => ({
  // CheckAvatarId: (id, region) => dispatch(AvatarAction.CheckAvatarId(id, region)),
});

export default connect(mapState, mapDispatch)(MPageHeader);
